import React, { FC } from "react";

import "./CommonAdvancedViewGrid.scss";

export const CommonAdvancedViewGrid: FC = ({ children }) => {
  return <div className="common-advanced-view-grid">{children}</div>;
};
